(function ($) {
  'use strict';
  $(function () {
    $(document).on('click', '.bill__arr', function () {
      $(this).closest(".bill__elem").toggleClass('bill__elem_opened')
    });

    $(document).on('click', '.contract__more__arrow', function () {
      $(".contract__more").toggleClass('opened');
      $(this).toggleClass('opened');
    });
  });
})(jQuery);
